<template>
  <div class='h-dialogContainer'>
    <form id='addRulesForm'>
      <div class='row h-row-inputBox'>
        <div class='col-sm-6 h-col-inputBox'>
          <div class='h-inputLit'>{{$t('Alarm.notificationRuleName')}}:</div>
          <ejs-textbox name='notificationRuleName' v-model='filterDatas.notificationRuleName'></ejs-textbox>
        </div>
        <div class='col-sm-6 h-col-inputBox'>
          <div class='h-inputLit'>{{$t('Alarm.notificationTimeRule')}}:</div>
          <div class='row'>
            <div v-for='(rulesTime, index) in rulesTimeList' :key='index' class='col-sm-4 nopadding' style='height: 32px;'>
              <ejs-radiobutton ref='ruleTime' name='rulesTime' :label='rulesTime.label' :value='rulesTime.value' :checked='rulesTime.checked' :change='radioFunc'></ejs-radiobutton>
            </div>
            <div style='float: left;'>
              <div v-show='this.rulesTimeListCheckValue === "1"' class='col-sm-4 nopadding'>
                <ejs-textbox name='notificationCycleValue' v-model='filterDatas.notificationCycleValue'></ejs-textbox>
              </div>
              <div v-show='this.rulesTimeListCheckValue === "1"' class='col-sm-4 nopadding' style='margin-left: 15px;'>
                <ejs-dropdownlist :dataSource='rulsTime.list' :fields='rulsTime.listFields' v-model='rulsTime.checkValue'></ejs-dropdownlist>
              </div>
            </div>
          </div>
        </div>
        <div class='col-sm-6 h-col-inputBox'>
          <div class='h-inputLit'>{{$t('Alarm.notifyUserGroup')}}:</div>
          <ejs-dropdownlist :dataSource='userGroup.list' :fields='userGroup.listFields' v-model='userGroup.checkValue'></ejs-dropdownlist>
        </div>
        <!-- <div class='col-sm-6 h-col-inputBox'>
          <div class='h-inputLit'>{{$t('Alarm.methodToInforme')}}:</div>
          <div class='row' id='methodArrayBox' style='margin-top: 5px; margin-bottom: 6px;'>
            <div v-for='(method, index) in methodList' :key='index' class='col-sm-3 nopadding'>
              <ejs-checkbox ref='methodsCheck' name='methodsCheckBox' :label='method.label' :value='method.value' :checked='method.checked'></ejs-checkbox>
            </div>
          </div>
        </div> -->
        <div class='col-sm-6 h-col-inputBox'>
          <div class='h-inputLit'>{{$t('Alarm.notityform')}}:</div>
          <ejs-dropdownlist :dataSource='notificationType.list' :fields='notificationType.listFields' v-model='notificationType.checkValue'></ejs-dropdownlist>
        </div>
        <!-- <div class='col-sm-6 h-col-inputBox'>
          <div class='h-inputLit'>{{$t('Alarm.notifytemplate')}}</div>
          <ejs-dropdownlist :dataSource='model.list' :fields='model.listFields' v-model='model.checkValue'></ejs-dropdownlist>
        </div> -->
        <div v-show='this.notificationType.checkValue === "0"' class='col-sm-6 h-col-inputBox'>
          <div class='h-inputLit'>{{$t('Alarm.alarmLevel')}}</div>
          <div class='row' id='alarmLevelBox'>
            <div v-for='(alarm, index) in alarmLevelList' :key='index' class='col-sm-3 nopadding'>
              <ejs-checkbox ref='alarmLevelCheck' :label='alarm.label' :value='alarm.value' :checked='alarm.checked'></ejs-checkbox>
            </div>
          </div>
        </div>
        <!-- 查询条件 -->
        <!-- <div v-show='this.notificationType.checkValue === "1"' class='col-sm-6 h-col-inputBox'>
          <div class='h-inputLit'>{{$t('Alarm.alarmLevel')}}</div>
          <div class='row' id='alarmLevelBox'>
            <div v-for='(alarm, index) in selectLevelList' :key='index' class='col-sm-3 nopadding'>
              <ejs-checkbox ref='alarmLevelCheck' name='alarmLevel' :label='alarm.label' :value='alarm.value' :checked='alarm.checked' :change='levelChangeFunc'></ejs-checkbox>
            </div>
          </div>
        </div>
        <div v-show='this.notificationType.checkValue === "1"' class='col-sm-12 h-col-inputBox'>
          <div class='h-inputLit'>{{$t('Alarm.neType')}}</div>
          <ejs-multiselect v-model='neTypeSelectData' :dataSource='neTypeData' :fields='neTypeFields' mode='CheckBox' :enableSelectionOrder='false' :showSelectAll='false' :change='neTypeChange'></ejs-multiselect>
        </div> -->
        <!-- 查询条件结束 -->
      </div>
      <div v-show='this.notificationType.checkValue === "1"' class='row h-row-inputBox'>
        <div class='col-sm-12 h-col-inputBox'>
          <div class='h-alarm-dialog-searchBorder'>
            <div class='col-sm-6 h-col-inputBox'>
              <div class='h-inputLit'>{{$t('Pm.ne_type_id')}}</div>
              <ejs-multiselect v-model='neTypeSelectData' :dataSource='neTypeData' :fields='neTypeFields' mode='CheckBox' :enableSelectionOrder='false' :showSelectAll='false' :change='neTypeChange'></ejs-multiselect>
            </div>
            <div class='col-sm-6 h-col-inputBox'>
              <div class='h-inputLit'>{{$t('Alarm.alarmLevel')}}</div>
              <div class='row' id='alarmLevelBox'>
                <div v-for='(alarm, index) in selectLevelList' :key='index' class='col-sm-3 nopadding'>
                  <ejs-checkbox ref='alarmLevelCheck' name='alarmLevel' :label='alarm.label' :value='alarm.value' :checked='alarm.checked' :change='levelChangeFunc' ></ejs-checkbox>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-show='this.notificationType.checkValue === "1"' class="row h-reset-margin">
        <div id='alarmTree'>
          <div class='h-padding-25 h-alarm-noPaddingBottom'>
            <div class='height-280'>
              <AlarmTable ref='alarmTable'></AlarmTable>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import { CheckBoxSelection } from '@syncfusion/ej2-vue-dropdowns';
import { FormValidator } from '@syncfusion/ej2-vue-inputs';
import AlarmTable from '../blockingRule/AlarmTable';
import { EventBus } from '../../../plugins/eventBus';

export default {
  name: 'addRules',
  components: {
    AlarmTable
  },
  data() {
    return {
      selectLevelList: [
        { label: this.$t('Alarm.alarmLevel_0'), value: '0', checked: false },
        { label: this.$t('Alarm.alarmLevel_1'), value: '1', checked: false },
        { label: this.$t('Alarm.alarmLevel_2'), value: '2', checked: false },
        { label: this.$t('Alarm.alarmLevel_3'), value: '3', checked: false }
      ],
      selectLevelArray: [],
      neTypeFields: { text: 'netype', value: 'netypeid' },
      neTypeData: [],
      neTypeSelectData: [],
      alarmLevelList: [
        { label: this.$t('Alarm.alarmLevel_0'), value: '0', checked: false },
        { label: this.$t('Alarm.alarmLevel_1'), value: '1', checked: false },
        { label: this.$t('Alarm.alarmLevel_2'), value: '2', checked: false },
        { label: this.$t('Alarm.alarmLevel_3'), value: '3', checked: false }
      ],
      rulesTimeList: [
        { label: this.$t('Alarm.realTime'), value: '0', checked: true },
        { label: this.$t('Alarm.periodic'), value: '1', checked: false }
      ],
      rulesTimeListCheckValue: '0',
      rulsTime: {
        listFields: { text: 'name', value: 'value' },
        list: [
          { name: this.$t('Alarm.minute'), value: 'minute' },
          { name: this.$t('Alarm.hour'), value: 'hour' },
          { name: this.$t('Alarm.day'), value: 'day' }
        ],
        checkValue: 'minute'
      },
      userGroup: {
        listFields: { text: 'name', value: 'value' },
        list: [],
        checkValue: ''
      },
      methodList: [
        { label: '邮件', value: '1', checked: true }
      ],
      notificationType: {
        listFields: { text: 'name', value: 'value' },
        list: [
          { name: this.$t('Alarm.notitylevel'), value: '0' },
          { name: this.$t('Alarm.notityitem'), value: '1' }
        ],
        checkValue: '1'
      },
      model: {
        listFields: { text: 'name', value: 'value' },
        list: [
          { name: '模板一', value: '0' }
        ],
        checkValue: '0'
      },
      filterDatas: {
        notificationRuleName: '',
        notificationCycleValue: '1'
      },
      validationOption: {
        customPlacement(inputElement, errorElement) {
          errorElement.style.position = 'fixed';
          inputElement.parentElement.parentElement.appendChild(errorElement);
        },
        rules: {
          notificationRuleName: {
            required: [true, `${this.$t('Alarm.fieldIsRequired')}`],
            maxLength: [30, `${this.$t('Alarm.maxLength')}30`],
            regex: [/^[^'\\"<>%&\s]+$/, `${this.$t('Alarm.notInputblank')} ' " \\ < > % &`]
          }
        }
      }
    };
  },
  provide: {
    multiselect: [CheckBoxSelection]
  },
  watch: {
    rulesTimeListCheckValue() {
      if (this.rulesTimeListCheckValue === '0') {
        this.formObj.removeRules('notificationCycleValue');
      } else if (this.rulesTimeListCheckValue === '1') {
        this.formObj.addRules('notificationCycleValue', {
          required: [true, `${this.$t('Alarm.fieldIsRequired')}`],
          regex: [/^\d+$/, `${this.$t('Alarm.notInteger')}`],
          min: [1, `${this.$t('Alarm.minValueIs')}1`],
          max: [36000, `${this.$t('Alarm.maxValueIs')}36000`]
        });
      }
    }
  },
  methods: {
    levelChangeFunc() {
      this.alarmLevelArray = this.getArray('alarmLevelBox');
      this.$refs.alarmTable.queryConditions.alarmLevelList = this.alarmLevelArray;
      this.$refs.alarmTable.getAlarmTableData();
    },
    neTypeChange() {
      this.$refs.alarmTable.queryConditions.neTypeList = this.neTypeSelectData;
      this.$refs.alarmTable.getAlarmTableData();
      console.log("this.neTypeSelectData", this.neTypeSelectData);
    },
    radioFunc(args) {
      this.rulesTimeListCheckValue = args.value;
    },
    selectTab(args) {
      if (args.selectedIndex === 1) {
        const neIdList = [];
        const nodeList = this.$refs.ruleTopoTree.getCacheNodeList();
        for (let i = 0; i < nodeList.length; i++) {
          if (nodeList[i].node !== null) {
            if (nodeList[i].node.netype !== 'subnetwork') {
              neIdList.push(nodeList[i].node.neid);
            }
          }
        }
        this.$refs.alarmTable.queryConditions.neList = neIdList;
        this.$refs.alarmTable.getAlarmTableData();
      }
    },
    getArray(id) {
      const checkedDom = document.querySelectorAll(`#${id} [aria-checked=true] input`);
      const array = [];
      for (let i = 0; i < checkedDom.length; i++) {
        array.push(checkedDom[i].value);
      }
      return array;
    },
    setRuleId(ruleInfo) {
      this.filterDatas.notificationRuleId = ruleInfo.notificationRuleId;
      this.filterDatas.notificationRuleName = ruleInfo.notificationRuleName;
      if (ruleInfo.notificationCycle === 0) {
        this.rulesTimeListCheckValue = '0';
        this.$refs.ruleTime[0].click();
      } else {
        this.rulesTimeListCheckValue = '1';
        this.$refs.ruleTime[1].click();
      }
      this.filterDatas.notificationCycleValue = ruleInfo.notificationCycle;
      this.rulsTime.checkValue = ruleInfo.cycleUnit;
      this.userGroup.checkValue = ruleInfo.userGroup;
      this.notificationType.checkValue = `${ruleInfo.notificationType}`;
      if (ruleInfo.notificationType === 1) {
        const alarms = ruleInfo.alarmsStr.split(',');
        for (let i = 0; i < ruleInfo.alarmNeTypeList.length; i++) {
          this.$refs.alarmTable.alarmListCache[ruleInfo.alarmNeTypeList[i].alarmId+'-'+ruleInfo.alarmNeTypeList[i].neTypeId] = true;
        }
      } else {
        const levels = ruleInfo.levelsStr.split(',');
        for (let i = 0; i < levels.length; i++) {
          // const index = Math.abs(parseInt(levels[i], 10) - 3);
          const index = levels[i];
          this.$refs.alarmLevelCheck[index].ej2Instances.checked = true;
        }
      }
    },
    clearData() {
      this.bindValidate();
      this.filterDatas = {
        notificationRuleName: '',
        notificationCycleValue: '1'
      };
      this.rulesTimeListCheckValue = '0';
      this.rulsTime.checkValue = 'minute';
      this.$refs.ruleTime[0].click();
      this.userGroup.checkValue = this.userGroup.list.length > 0 ? this.userGroup.list[0].value : '';
      this.notificationType.checkValue = '1';
      for (let i = 0; i < this.$refs.alarmLevelCheck.length; i++) {
        this.$refs.alarmLevelCheck[i].ej2Instances.checked = false;
      }
      this.$refs.alarmTable.clearCache();
      const errorDom = document.querySelectorAll('label.e-error');
      for (let i = 0; i < errorDom.length; i++) {
        errorDom[i].innerHTML = '';
      }
    },
    getAlarmIdList() {
      const alarmIdList = [];
      const alarmArray = this.$refs.alarmTable.getCheckedData();
      for (let i = 0; i < alarmArray.length; i++) {
        alarmIdList.push(alarmArray[i].alarmid);
      }
      return alarmIdList;
    },
    getAlarmFilterDatas() {
      // 获取保存所需特定格式
      const timeRule = document.querySelectorAll('.e-radio:checked')[0].value;
      const methodArray = ['1'];
      let alarmArray = this.$refs.alarmTable.getCheckedData();
      let alarmLevelArray = this.getArray('alarmLevelBox');
      let notificationCycle = '';
      let cycleUnit = '';
      if (!this.validate()) {
        return false;
      }
      if (timeRule === '1') {
        notificationCycle = this.filterDatas.notificationCycleValue;
        cycleUnit = this.rulsTime.checkValue;
        if (!notificationCycle) {
          EventBus.$emit('toast', {type: 'warning', content: this.$t('Alarm.notificationTimenull')});
          return false;
        }
      } else {
        notificationCycle = '0';
        cycleUnit = 'minute';
      }
      if (this.notificationType.checkValue === '0') {
        alarmArray = [];
        if (alarmLevelArray.length === 0) {
          EventBus.$emit('toast', {type: 'warning', content: this.$t('Alarm.alarmLevelnull')});
          return false;
        }
      }
      if (this.notificationType.checkValue === '1') {
        alarmLevelArray = [];
        if (alarmArray.length === 0) {
          EventBus.$emit('toast', {type: 'warning', content: this.$t('Alarm.alarmnull')});
          return false;
        }
      }
      if (methodArray.length === 0) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('Alarm.notificationMethodnull')});
        return false;
      }
      if (!this.userGroup.checkValue) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('Alarm.notifyUserNotExist')});
        return false;
      }
      const notificationRuleData = {
        notificationname: this.filterDatas.notificationRuleName,
        notification: this.notificationType.checkValue,
        neName: '', // 网元树的搜索框关键词
        timeRule
      };
      if (this.notificationType.checkValue === '1') {
        notificationRuleData.alarmid = this.getAlarmIdList();
      }
      const returnData = {
        notificationRule: notificationRuleData,
        notificationRuleName: this.filterDatas.notificationRuleName,
        notificationType: this.notificationType.checkValue,
        levels: alarmLevelArray,
        methods: methodArray,
        alarmStaticInfo: alarmArray, // 告警列表的勾选节点，未加表格
        notificationCycle,
        userGroup: this.userGroup.checkValue,
        template: this.model.checkValue,
        cycleUnit
      };
      if (this.filterDatas.notificationRuleId !== undefined) {
        returnData.notificationRuleId = this.filterDatas.notificationRuleId;
      }
      return returnData;
    },
    bindValidate() {
      this.formObj = new FormValidator('#addRulesForm', this.validationOption);
    },
    validate() {
      const formStatus = this.formObj.validate();
      return formStatus;
    },
    getRulesData() { // 获取用户组数据
      this.$axios.post('/lte/ems/fm/notification/notification').then((response) => {
        if (response && response.status === 200) {
          const userGroups = [];
          for (let i = 0; i < response.data.userGroups.length; i++) {
            userGroups.push({
              name: response.data.userGroups[i],
              value: response.data.userGroups[i]
            });
          }
          this.userGroup = {
            listFields: { text: 'name', value: 'value' },
            list: userGroups,
            checkValue: userGroups.length > 0 ? userGroups[0].value : ''
          };
        }
      });
    },
    getNeTypeData() {
      let arr = [];
      // this.$axios.post('/lte/ems/topo/device/devType').then((response) => {
        this.$axios.post('/lte/ems/topo/ne/findNeTypeMain').then((response) => {
        if (response && response.status === 200) {
          arr = response.data.resultVal;
          this.neTypeData = arr.filter((x, index,self)=>{
              // 资源类型只显示enodeb类型
              if (x.netypeid == 10004) {
                var arrids = []
                arr.forEach((item,i) => {
                  arrids.push(item.netypeid)
                })
                return arrids.indexOf(x.netypeid) === index
              }
            })
        }
      });
    },
  },
  beforeMount() {
    this.getRulesData();
    this.getNeTypeData();
  },
  mounted() {
    this.bindValidate();
  }
};
</script>
